import { useMemo } from "react";
import {
  WRONG_US_ZIP_FORMAT,
  WRONG_ZIP_FORMAT,
  WRONG_ZIP_LENGTH,
} from "../constants";
import { Rule } from "antd/es/form";
import { US_ZIP_INPUT_RULE, ZIP_INPUT_RULE } from "../validationRules";

export const useZipCodeRules = (strict: boolean = false) => {
  const rules: Rule[] = useMemo(
    () => [
      {
        min: 5,
        max: 10,
        message: WRONG_ZIP_LENGTH,
        validateTrigger: "onSubmit",
      },
      {
        pattern: strict ? US_ZIP_INPUT_RULE : ZIP_INPUT_RULE,
        message: strict ? WRONG_US_ZIP_FORMAT : WRONG_ZIP_FORMAT,
        validateTrigger: "onSubmit",
      },
    ],
    [strict],
  );

  return { rules };
};
